import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormControl } from '../FormControl/component.class.js';
import { GetValidationPattern } from '../../utils/ValidationUtil.js';
import { i18n } from '../../i18n/translate.js';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';
var _excluded = ["setError", "name", "placeholder", "valueOverride", "disablePicker", "format", "timeFormat"];

var DateTimePickerControl = /*#__PURE__*/function (_FormControl) {
  // TODO: refactor type
  function DateTimePickerControl(props) {
    var _this;

    _classCallCheck(this, DateTimePickerControl);

    _this = _callSuper(this, DateTimePickerControl, [props]);

    _defineProperty(_this, "checkForManual", function () {
      var _this$picker;

      var _this$state = _this.state,
          target = _this$state.target,
          manualValueForValidation = _this$state.manualValueForValidation;

      if (!target || !_this.picker) {
        return;
      }

      var pickerHasValue = _this.picker.props.value && _this.picker.props.value !== '';
      var currentYear = manualValueForValidation ? moment(manualValueForValidation).format('YYYY') : moment().format('YYYY');
      var currentMonth = manualValueForValidation ? moment(manualValueForValidation).format('MM') : moment().format('MM');
      var currentDay = manualValueForValidation ? moment(manualValueForValidation).format('DD') : moment().format('DD');

      var _this$picker$wrapper$ = (_this$picker = _this.picker) === null || _this$picker === void 0 || (_this$picker = _this$picker.wrapper) === null || _this$picker === void 0 ? void 0 : _this$picker.querySelectorAll('input'),
          _this$picker$wrapper$2 = _slicedToArray(_this$picker$wrapper$, 4);

      _this$picker$wrapper$2[0];
      var yearInput = _this$picker$wrapper$2[1],
          monthInput = _this$picker$wrapper$2[2],
          dayInput = _this$picker$wrapper$2[3]; // eslint-disable-line no-unused-vars

      var year = yearInput.value || currentYear;
      var month = monthInput.value || currentMonth;
      var day = dayInput.value || currentDay;
      year = year.padStart(4, '0');
      month = month.padStart(2, '0');
      day = day.padStart(2, '0');

      var values = _this.formatDate(moment("".concat(year, "-").concat(month, "-").concat(day)).format('YYYY-MM-DD'));

      _this.setState({
        manualValueForValidation: pickerHasValue ? values.value : null
      }, _this.checkError);
    });

    _defineProperty(_this, "onBlur", function (e) {
      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur(_this.state.value);
      }

      _this.setState({
        target: e.target
      }, _this.checkForManual);
    }); // TODO: update type to remove 'any'


    _defineProperty(_this, "formatDate", function (value) {
      var dateFormatValue = value && moment.isMoment(value) ? new Date(value.format(_this.props.momentFormat)) : value;
      value = value && moment(value);
      var formattedValue = value && moment.isMoment(value) ? value.format(_this.props.momentFormat) : '';
      return {
        value: dateFormatValue,
        formattedValue: formattedValue
      };
    }); // TODO: update type to remove 'any'


    _defineProperty(_this, "onChange", function (value, skipValueChange) {
      if (!_this.isValidDate(value)) {
        if (value !== null && value !== void 0 && value.target) {
          _this.setState({
            target: value.target
          }, // @ts-ignore
          _this.checkForManual());
        }

        return false;
      }

      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(value);
      }

      var values = _this.formatDate(value);

      if (typeof _this.props.onValueChange === 'function' && !skipValueChange) {
        _this.props.onValueChange(_defineProperty({}, _this.props.name, values.formattedValue));
      }

      _this.setState({
        value: values.value,
        formattedValue: values.formattedValue,
        manualValueForValidation: null
      });
    });

    _defineProperty(_this, "isValidDate", function (value) {
      var dateValue = new Date(value);

      if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
        var year = dateValue.getFullYear();
        return !(year.toString().length > 4);
      }

      return false;
    });

    _defineProperty(_this, "isValid", function () {
      var input = _this.input;
      var manualValToCheck = _this.state.manualValueForValidation ? _this.state.manualValueForValidation : _this.state.value;

      if (input) {
        if (!_this.props.required && !input.value) {
          return true;
        }

        if (_this.props.maxValidDate && input.value) {
          return input.validity.valid && moment(input.value).isValid() && moment(input.value).isBefore(_this.props.maxValidDate);
        }

        if (_this.props.minDate && manualValToCheck) {
          // using state.manualValToCheck for dates before today. input.value will not update before minDate
          return moment(manualValToCheck).isSameOrAfter(moment(_this.props.minDate));
        }

        return input.validity.valid && moment(input.value).isValid();
      }
    });

    _defineProperty(_this, "checkError", function () {
      var message = null;
      var node = _this.input;
      var manualValToCheck = _this.state.manualValueForValidation ? _this.state.manualValueForValidation : _this.state.value;

      if (node) {
        if (!manualValToCheck && node.validity.valueMissing && _this.props.required) {
          message = i18n.t('This field is required');
        } else if (manualValToCheck && !_this.isValidDate(manualValToCheck)) {
          message = i18n.t('The date you entered is invalid');
        } else if (manualValToCheck && !moment(manualValToCheck, 'YYYY-MM-DD').isValid() || !manualValToCheck && !node.validity.valid) {
          message = i18n.t('The date you entered is invalid');
        } else if (node.value && _this.props.maxValidDate && !moment(node.value).isBefore(_this.props.maxValidDate)) {
          message = i18n.t('The date cannot be in the future.');
        } else if (manualValToCheck && _this.props.minDate && !moment(manualValToCheck).isSameOrAfter(_this.props.minDate)) {
          // using state.value for dates before today. node.value will not update before minDate
          message = i18n.t('The date cannot be in the past.');
        } else if (!node.value && !_this.props.required) {
          message = null;
        }
      }

      if (typeof _this.props.setError === 'function') {
        _this.props.setError(!_this.isValid(), message || '');
      }
    }); // TODO: update type to remove 'any'


    _defineProperty(_this, "onRef", function (picker) {
      _this.picker = picker;

      if (_this.picker) {
        var pickerEl = _this.picker.wrapper;
        pickerEl.tabIndex = -1; // this is a hack to deal with this bug in react-datetime-picker: https://github.com/wojtekmaj/react-datetime-picker/issues/56

        _this.input = pickerEl === null || pickerEl === void 0 ? void 0 : pickerEl.querySelector('input');
      }
    });

    var _value = '';
    var _formattedValue = '';

    if (props.dataValue) {
      _value = props.utc ? moment.utc(props.dataValue) : moment(props.dataValue);
      _formattedValue = _value.format(props.momentFormat);
    }

    if (_value && moment.isMoment(_value)) {
      _value = new Date(_value.format(props.momentFormat));
    }

    _this.pattern = GetValidationPattern('datetime');
    var newState = {
      value: _value,
      formattedValue: _formattedValue,
      manualValueForValidation: null,
      target: null
    };
    _this.state = newState;
    return _this;
  }

  _inherits(DateTimePickerControl, _FormControl);

  return _createClass(DateTimePickerControl, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          dataValue = _this$props.dataValue,
          utc = _this$props.utc,
          valueOverride = _this$props.valueOverride;

      if (valueOverride) {
        var value = dataValue;
        var valuesMatch = false;

        if (value) {
          value = utc === true ? moment.utc(value) : moment(value);
        }

        if (moment.isMoment(this.state.value)) {
          valuesMatch = this.state.value.isSame(value);
        } else if (moment.isMoment(value)) {
          valuesMatch = value.isSame(this.state.value);
        } else {
          valuesMatch = this.state.value === value;
        }

        if (!valuesMatch) {
          this.onChange(value, true);
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_, nextState) {
      return !(this.props.closeOnSelect && this.state.value === nextState.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props;
      _this$props2.setError;
      var name = _this$props2.name;
      _this$props2.placeholder;
      _this$props2.valueOverride;

      var disablePicker = _this$props2.disablePicker,
          format = _this$props2.format,
          timeFormat = _this$props2.timeFormat,
          props = _objectWithoutProperties(_this$props2, _excluded); // eslint-disable-line no-unused-vars


      var formattedValue = this.state.formattedValue;
      var inputId = name;
      var newFormat = timeFormat ? 'yyyy/MM/dd h:mm:ss a' : format;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DateTimePicker, _extends({}, props, {
        disabled: disablePicker,
        disableClock: !timeFormat,
        format: newFormat // @ts-ignore
        ,
        onBlur: this.onBlur,
        onChange: this.onChange,
        ref: this.onRef,
        value: this.state.value
      })), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "".concat(inputId, "_formatted"),
        value: formattedValue,
        name: name
      }));
    }
  }]);
}(FormControl);

_defineProperty(DateTimePickerControl, "defaultProps", _objectSpread2(_objectSpread2({}, FormControl.defaultProps), {}, {
  amPmAriaLabel: 'Select AM/PM',
  calendarAriaLabel: 'Toggle calendar',
  clearAriaLabel: 'Clear value',
  dayAriaLabel: 'Day',
  disablePicker: false,
  format: 'yyyy/MM/dd',
  hourAriaLabel: 'Hour',
  maxDate: new Date(9999, 12, 0),
  minuteAriaLabel: 'Minute',
  momentFormat: 'YYYY-MM-DDTHH:mm:ss.sssZ',
  monthAriaLabel: 'Month',
  nativeInputAriaLabel: 'Date',
  secondAriaLabel: 'Second',
  yearAriaLabel: 'Year'
}));

DateTimePickerControl.displayName = "DateTimePickerControl";
export { DateTimePickerControl };